<template>
    <div class="product-selection tabs-container">
        <div class="tab-content">
            <div id="tab-case" :class="getClass('case')" class="tab-pane">
                <tab-content :content-info="caseTabInfo"/>
            </div>
            <div id="tab-cooling" :class="getClass('cooling')" class="tab-pane">
                <tab-content :content-info="coolingTabInfo"/>
            </div>
            <div id="tab-motherboard" :class="getClass('motherboard')" class="tab-pane">
                <tab-content :content-info="motherboardTabInfo"/>
            </div>
            <div id="tab-gpu" :class="getClass('gpu')" class="tab-pane">
                <tab-content :content-info="gpuTabInfo"/>
            </div>
            <div id="tab-cpu" :class="getClass('cpu')" class="tab-pane">
                <tab-content :content-info="cpuTabInfo"/>
            </div>
            <div id="tab-psu" :class="getClass('psu')" class="tab-pane">
                <tab-content :content-info="psuTabInfo"/>
            </div>
            <div id="tab-ram" :class="getClass('ram')" class="tab-pane">
                <tab-content :content-info="ramTabInfo"/>
            </div>
            <div id="tab-ssd" :class="getClass('storage')" class="tab-pane">
                <tab-content :content-info="storageTabInfo"/>
            </div>
            <div v-if="sessionData && sessionData.colors" id="tab-color" :class="getClass('color')" class="tab-pane">
                <colors-tab :colors="sessionData.colors" :default-selected-colors="sessionData.defaultBuild.colors"/>
            </div>
            <div id="tab-rgbs" :class="getClass('rgbs')" class="tab-pane">
                <tab-content :content-info="rgbsTabInfo"/>
            </div>
            <div id="tab-extra" :class="getClass('extras')" class="tab-pane">
                <tab-content :content-info="accesoriesTabInfo"/>
            </div>
            <div id="tab-peripherals" :class="getClass('peripherals')" class="tab-pane">
                <tab-content :content-info="peripheralsTabInfo"/>
            </div>
            <div id="tab-monitor" :class="getClass('monitor')" class="tab-pane">
                <tab-content :content-info="monitorTabInfo"/>
            </div>
            <div id="tab-software" :class="getClass('software')" class="tab-pane">
                <tab-content :content-info="softwareTabInfo"/>
            </div>
            <div id="tab-services" :class="getClass('services')" class="tab-pane">
                <tab-content :content-info="servicesTabInfo"/>
            </div>
        </div>
    </div>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import TabContent from "./components/tab-content/tab-content.vue";
import ColorsTab from "./components/colors-tab";

export default {
    name: "ProductsTabs",
    components: {
        TabContent,
        ColorsTab,
    },
    props: {
        activeBuild: {
            type: Object,
            default() {
                return {};
            }
        },
        sessionData: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(["activeTab"]),
        casesColorsList() {
            const groupedCaseColors = _.groupBy(this.sessionData.case, "products_id");
            return groupedCaseColors[this.build.case.products_id];
        },
        extrasColorsList() {
            const groupedExtrasColors = _.groupBy(this.sessionData.extras, "products_id");
            return groupedExtrasColors;
        },
        groupedCases() {
            const orderedCases = {};

            this.sessionData.case.forEach(_case => {
                if (!orderedCases.hasOwnProperty(`_${_case.cases_series_id}`)) {
                    orderedCases[`_${_case.cases_series_id}`] = [];
                }

                orderedCases[`_${_case.cases_series_id}`].push(_case);
                orderedCases[`_${_case.cases_series_id}`].reverse();
            });

            return orderedCases;
        },
        groupedCooloers() {
            const sessionData = _cloneDeep(this.sessionData);
            const coolers = [];
            // Reserving space for H7s
            coolers[0] = [];

            sessionData.cooling.forEach((cooler) => {
                if (cooler.name.toUpperCase().startsWith("CRYORIG")) {
                    cooler.cases_series_id = 1;
                    coolers[0].push(cooler);
                } else {
                    coolers.push([cooler]);
                }
            });

            if (coolers[0].length) {
                coolers[0] = _.sortBy(coolers[0], "price").reverse();
            } else {
                coolers.splice(0, 1);
            }

            return coolers;
        },
        groupedRgbs() {
            const sessionData = _cloneDeep(this.sessionData);
            const rgbs = [];

            sessionData.rgbs.forEach((rgb) => {
                if (rgb.name.match(/hue ?2 ambient/i)) {
                    rgb.options.forEach((ambient) => {
                        ambient.cases_series_id = 1;
                        ambient.description = ambient.variant_description;
                        ambient.image = rgb.image;
                        ambient.render = rgb.render;
                    });

                    rgbs.push(rgb.options.reverse());
                } else {
                    rgbs.push([rgb]);
                }
            });

            return rgbs;
        },
        limitedCases() {
            const sessionData = _cloneDeep(this.sessionData);
            const cases = [];
            const limited = sessionData.colors.case.filter(item => +item.is_limited === 1);

            limited.forEach(item => {
                const product = item;
                product.id = item.id;
                product.price = item.price;
                product.name = item.title;
                product.cover = item.images_render;
                product.render = item.images_render;
                product.image = item.images_render;
                product.is_limited = 1;
                product.limitedPartName = "case";

                cases.push(product);
            });

            return _.sortBy(cases, item => +item.price);
        },
    },
    data() {
        return {
            caseTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'case-options',
                        slug: "cases"
                    },
                    {
                        name: 'SPECIAL EDITION',
                        class: 'config-tab-option',
                        link: 'limited-cases',
                        slug: "limited-cases"
                    },
                ],
                rowsContent: []

            },
            coolingTabInfo: {
                navTabsInfo: [
                    {
                        name: 'CPU COOLERS',
                        class: 'config-tab-option',
                        link: 'cooling-options',
                        slug: "coolers"
                    },
                    {
                        name: 'CASE FANS',
                        class: 'config-tab-option',
                        link: 'cooling-fans',
                        slug: "fans"
                    }
                ],
                rowsContent: []
            },
            motherboardTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'motherboard-options',
                        slug: "motherboards"
                    },
                ],
                rowsContent: []
            },
            gpuTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'gpu-options',
                        slug: "gpus"
                    },
                ],
                rowsContent: []
            },
            cpuTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'cpu-options',
                        slug: "cpus"
                    },
                ],
                rowsContent: []
            },
            psuTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'psu-options',
                        slug: "psus"
                    }
                ],
                rowsContent: []
            },
            ramTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'ram-options',
                        slug: "ram"
                    }
                ],
                rowsContent: []
            },
            storageTabInfo: {
                navTabsInfo: [
                    {
                        name: 'SSD',
                        class: 'config-tab-option',
                        link: 'ssd-options',
                        slug: "storage-ssd"
                    },
                    {
                        name: 'HDD',
                        class: 'config-tab-option',
                        link: 'hdd-options',
                        slug: "storage-hdd"
                    }
                ],
                rowsContent: []
            },
            colorsTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'color-options',
                        slug: "colors"
                    }
                ],
                rowsContent: []
            },
            rgbsTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'rgbs-options',
                        slug: "rgbs"
                    }
                ],
                rowsContent: []
            },
            accesoriesTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'extra-options',
                        slug: "extras"
                    }
                ],
                rowsContent: []
            },
            peripheralsTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'peripheral-options',
                        slug: "peripherals"
                    }
                ],
                rowsContent: []
            },
            softwareTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'software-options',
                        slug: "softwares"
                    }
                ],
                rowsContent: []
            },
            servicesTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'service-options',
                        slug: "services"
                    }
                ],
                rowsContent: []
            },
            monitorTabInfo: {
                navTabsInfo: [
                    {
                        name: 'OPTIONS',
                        class: 'config-tab-option',
                        link: 'monitor-options',
                        slug: "monitors"
                    }
                ],
                rowsContent: []
            },
        };
    },
    watch: {
        sessionData() {
            this.setRowsContent();
        }
    },
    created() {
        if (this.sessionData.cpu) {
            this.setRowsContent(this.sessionData);
        }
    },
    methods: {
        getClass(tab) {
            if (tab == this.activeTab) {
                return 'active';
            }
            return '';
        },
        setRowsContent() {
           this.coolingTabInfo.rowsContent = [
                {
                    id: 'cooling-options',
                    data: this.groupedCooloers,
                    buttonsType: 'single',
                    type: 'innerTabs',
                    partName: 'cpuCooler',
                    canDeselect: false
                },
                {
                    id: 'cooling-fans',
                    data: this.sessionData.fans,
                    buttonsType: 'double',
                    type: 'standard',
                    partName: 'caseFans',
                    availabeQuantity: 3
                }
            ],
            this.caseTabInfo.rowsContent = [
                {
                    id: 'case-options',
                    data: this.groupedCases,
                    buttonsType: 'single',
                    type: 'innerTabs',
                    partName: 'case',
                    canDeselect: false
                },
                {
                    id: 'limited-cases',
                    data: this.limitedCases,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'case',
                    canDeselect: false
                }
            ],
            this.motherboardTabInfo.rowsContent = [
                {
                    id: 'motherboard-options',
                    data: this.sessionData.motherboards,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'motherboard',
                    canDeselect: false
                }
            ],
            this.gpuTabInfo.rowsContent = [
                {
                    id: 'gpu-options',
                    data: this.sessionData.gpu,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'gpu',
                    availabeQuantity: 1,
                }
            ],
            this.cpuTabInfo.rowsContent = [
                {
                    id: 'cpu-options',
                    data: this.sessionData.cpu,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'cpu',
                    canDeselect: false
                }
            ],
            this.psuTabInfo.rowsContent = [
                {
                    id: 'psu-options',
                    data: this.sessionData.powerSupplies,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'powerSupply',
                    canDeselect: false
                }
            ],
            this.ramTabInfo.rowsContent = [
                {
                    id: 'ram-options',
                    data: this.sessionData.ram,
                    buttonsType: 'selects',
                    type: 'standard',
                    partName: 'ram',
                    availabeQuantity: 2,
                    canDeselect: false
                }
            ],
            this.storageTabInfo.rowsContent = [
                {
                    id: 'ssd-options',
                    data: this.sessionData.ssd,
                    buttonsType: 'selects',
                    type: 'standard',
                    partName: 'ssd',
                    availabeQuantity: 3
                },
                {
                    id: 'hdd-options',
                    data: this.sessionData.hdd,
                    buttonsType: 'double',
                    type: 'standard',
                    partName: 'hdd',
                    availabeQuantity: 3,
                }
            ],
            this.colorsTabInfo.rowsContent = [
                {
                    id: 'color-options',
                    data: this.extrasColorsList,
                    buttonsType: 'single',
                    type: 'colors'
                }
            ],
            this.rgbsTabInfo.rowsContent = [
                {
                    id: 'rgbs-options',
                    data: this.groupedRgbs,
                    buttonsType: 'single',
                    type: 'innerTabs',
                    partName: 'rgbs',
                    canDeselect: true
                }
            ],
            this.accesoriesTabInfo.rowsContent = [
                {
                    id: 'extra-options',
                    data: this.sessionData.extras,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'extras',
                    canDeselect: true
                }
            ],
            this.peripheralsTabInfo.rowsContent = [
                {
                    id: 'peripheral-options',
                    data: this.sessionData.peripherals,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'peripherals',
                    canDeselect: true
                }
            ],
            this.softwareTabInfo.rowsContent = [
                {
                    id: 'software-options',
                    data: this.sessionData.software,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'software',
                    canDeselect: false
                }
            ],
            this.servicesTabInfo.rowsContent = [
                {
                    id: 'service-options',
                    data: this.sessionData.services,
                    buttonsType: 'single',
                    type: 'standard',
                    partName: 'services',
                    canDeselect: false
                }
            ],
            this.monitorTabInfo.rowsContent = [
                {
                    id: 'monitor-options',
                    data: this.sessionData.monitors,
                    buttonsType: 'double',
                    type: 'standard',
                    partName: 'monitors',
                    availabeQuantity: 3
                }
            ]
        }
    }
}
</script>
